@for (constraint of existingConstraints | orderByKey: 'priority' : 'asc'; track constraint; let k = $index) {
  @if (readonly) {
    @if (constraint.type !== 'unknown' || (isAdmin$ | async)) {
      <app-mediego-constraint-readonly
        [constraint]="constraint">
      </app-mediego-constraint-readonly>
    }
  } @else {
    @if (constraint.type !== 'unknown' || (isAdmin$ | async)) {
      <app-mediego-constraint
        (removeConstraint)="removeConstraintHandler(k)"
        (updateConstraint)="updateConstraintHandler($event, k)"
        [existingConstraint]="constraint" [index]="k"
        [constraintTypes]="constraintTypes">
      </app-mediego-constraint>
    }
  }
}

@if (existingConstraints && existingConstraints.length === 0) {
  <p class="no-constraints">
    {{ 'COMMON.CONSTRAINTS.EMPTY' | translate }}
  </p>
}

@if (unknownConstraints && (isAdmin$ | async) === false) {
  <p>
    {{ unknownConstraints }} {{ (unknownConstraints > 1 ? 'COMMON.CONSTRAINTS.UNKNOWN_NOT_DISPLAYED.PLURAL' : 'COMMON.CONSTRAINTS.UNKNOWN_NOT_DISPLAYED') | translate }}
  </p>
}

<!-- CREATE NEW CONSTRAINT -->
@if (readonly === false) {
  <app-mediego-constraint (addConstraint)="addConstraintHandler($event)"
    [constraintsFor]="constraintsFor"
    [constraintTypes]="constraintTypes">
  </app-mediego-constraint>
}
